"use client"

import { getCookies } from "@/utils/frontend/cookieOps"
import { detectLang } from "@/utils/frontend/langOps"
import { capitalizeEveryWord } from "@/utils/frontend/stringOps"
import { useEffect, useState } from "react"


const SignInAuthPage = () => {
  const [lang, setLang] = useState('en')
  const [user, setUser] = useState({...getCookies().user})
  const [organization, setOrganization] = useState({...getCookies().organization})


  const getData = async () => {
    // let orgResponse = await fetch(`/api/organizations/${user?.user_organization_id}?user_type=EMPLOYER`, {
    //   method: `GET`,
    //   headers: {
    //     Accept: "*/*",
    //     "Content-Type": "application/json",
    //   },
    //   credentials: "include", // If you are sending cookies with a cross-origin request, use 'include'
    // });
    // let orgResponseJSON = await orgResponse.json()
    // // console.log(orgResponseJSON)
    setOrganization({})
  }

  useEffect(() => {
  
    // setLang(detectLang(window.location.pathname))
    getData()
  }, [])
  
     return (
          <> 
          <title>{lang === 'fr' ? 'Console - Talnet' : 'Dashboard - Talnet'}</title>
<div className='flex flex-col items-center justify-center place-items-center h-screen text-base text-gray-400 font-base'>
      <div className="font-extralight text-3xl font-montserrat">
  
      </div><br/>
      {/* {organization.organization_jobs?.length > 0 && <div className="font-inter">
        {lang === 'fr' ? <>{capitalizeEveryWord(getCookies().organization?.organization_name)} a {getCookies().organization.organization_jobs?.length} offre(s) d'emploi publiée(s).</>
        :
        <>
          {capitalizeEveryWord(getCookies().organization?.organization_name)} has {getCookies().organization?.organization_jobs?.length} job listing(s).
        </>
        } 
        </div>} */}
</div>
          </>
     )
}

export default SignInAuthPage